<template>
	<div class="cand-dashboard-maincontainer">
		<header class="cand-header mb-10px">
			<img
				class="mr-3 pointer"
				@click="goBack()"
				src="../../assets/img/homepage/back-arrow-blue.svg"
				alt=""
			/>
			<img
				class="mr-2"
				src="../../assets/newdesign/dashboard/games/gamesHeader.svg"
				alt=""
			/>
			Games
		</header>
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="goBack()"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Games
		</header>
		<b-container class="game-grid-container app-bottom-padding">
			<b-container class="game-left">
				<b-card class="game-card" @click="gotoSingleGame('2048', 0)">
					<div class="d-flex flex-column justify-content-between h-100">
						<div class="text-left">
							<h1 class="game-white-txt">2048</h1>
							<span class="game-white-txt-2 double-line-truncate"
								>Combine numbered tiles to reach the tile 2048.</span
							>
						</div>

						<!-- <b-button v-if="isLastGameResume">Resume</b-button> -->
						<b-button>Play Now</b-button>
					</div>

					<img
						class="game-img-pos"
						src="../../assets/newdesign/dashboard/games/2048.svg"
						alt=""
					/>
				</b-card>
				<b-card class="game-card">
					<div class="d-flex flex-column justify-content-between h-100">
						<div class="text-left">
							<h1 class="game-white-txt">Wordle</h1>
							<span class="game-white-txt-2 double-line-truncate"
								>Guess the 5-letter word within 6 tries.</span
							>
						</div>
						<b-button @click="gotoSingleGame('wordle', 1)">Play Now</b-button>
					</div>

					<img
						class="game-img-pos"
						src="../../assets/newdesign/dashboard/games/wordle.svg"
						alt=""
					/>
				</b-card>
				<b-card class="game-card">
					<div class="d-flex flex-column justify-content-between h-100">
						<div class="text-left">
							<h1 class="game-white-txt">Sudoku</h1>
							<span class="game-white-txt-2 double-line-truncate"
								>Fill the 9x9 grid so that each row, column, and 3x3 box with
								1-9.</span
							>
						</div>

						<!-- <b-button v-if="isSudokuResume">Resume</b-button> -->

						<b-button @click="gotoSingleGame('sudoku', 2)">Play Now</b-button>
					</div>

					<img
						class="game-img-pos"
						src="../../assets/newdesign/dashboard/games/sudoku.svg"
						alt=""
					/>
				</b-card>
				<b-card class="game-card">
					<div class="d-flex flex-column justify-content-between h-100">
						<div class="text-left">
							<h1 class="game-white-txt">Crosswords</h1>
							<span class="game-white-txt-2 double-line-truncate"
								>Fill the grid with correct words based on the given
								clues.</span
							>
						</div>

						<!-- <b-button v-if="isCrosswordResume">Resume</b-button> -->

						<b-button @click="gotoSingleGame('crossword', 4)"
							>Play Now</b-button
						>
					</div>

					<img
						class="game-img-pos"
						src="../../assets/newdesign/dashboard/games/crossword.svg"
						alt=""
					/>
				</b-card>
			</b-container>
			<LeaderBoard />
		</b-container>
	</div>
</template>

<script>
import LeaderBoard from "@/components/Games/LeaderBoard.vue";
import { getGameState } from "@/utils/apiFunctions";
export default {
	data() {
		return {
			isWordleResume: false,
			isSudokuResume: false,
			isCrosswordResume: false,
			isLastGameResume: false,
		};
	},
	components: {
		LeaderBoard,
	},
	mounted() {
		// const keys = ["wordle", "sudoku", "crossword", "2048"];
		// const promises = keys.map(async (key, index) => {
		// 	try {
		// 		const exists = await getGameState(key);
		// 		if (exists.status === 200) {
		// 			if (key == "2048") this.isLastGameResume = true;
		// 			else if (key == "wordle") this.isWordleResume = true;
		// 			else if (key == "sudoku") this.isSudokuResume = true;
		// 			else this.isCrosswordResume = true;
		// 		} else {
		// 			if (key == "2048") this.isLastGameResume = false;
		// 			else if (key == "wordle") this.isWordleResume = false;
		// 			else if (key == "sudoku") this.isSudokuResume = false;
		// 			else this.isCrosswordResume = false;
		// 		}
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
		// });
		// Promise.all(promises);
		// this.$forceUpdate();
	},
	methods: {
		async stateExist(key) {
			const res = await getGameState(key);
			return res.status === 200;
		},

		async checkState(key) {
			const exists = await stateExist(key);
			return exists;
		},

		gotoSingleGame(gameType, gameId) {
			this.$router.push({
				name: "SingleGame",
				query: {
					gameType: gameType,
				},
			});
		},

		goBack() {
			this.$router.push({
				name: "Homepage",
			});
		},
	},
};
</script>

<style>
.game-grid-container {
	display: grid;
	grid-template-columns: 2.5fr 1fr;
	gap: 10px;
	max-width: 1825px;
	padding: 0;
	height: calc(100vh - 152px);
}

.game-left {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 0fr 0fr;
	gap: 10px;
	padding: 0;
	max-width: 100%;
	height: 100%;
	overflow: auto;
}

.game-card {
	background: linear-gradient(180deg, rgba(32, 99, 155, 0.62) 0%, #000000 100%);
	height: 230px;
	border-radius: 8px;
	border: none;
	overflow: hidden;
	position: relative;
}
.game-card:hover .game-img-pos {
	transform: scale(1.2);
}

.game-card .card-body {
	width: 52%;
}

.game-img-pos {
	position: absolute;
	right: -1px;
	bottom: -1px;
	transition: all 0.5s ease;
}

.game-white-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-24);
	font-weight: var(--weight-B);
	color: var(--bg-white);
}

.game-white-txt-2 {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-R);
	color: var(--bg-white);
}

.game-card .btn-secondary {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-B);
	color: var(--bg-proTheme);
	background-color: var(--bg-white);
	border-radius: 25px;
	width: fit-content;
	padding: 4px 30px;
	margin: 0;
	box-shadow: none;
}
.game-card .btn-secondary:not(:disabled):not(.disabled):active,
.game-card .btn-secondary:not(:disabled):not(.disabled).active,
.show > .game-card .btn-secondary.dropdown-toggle {
	color: var(--bg-proTheme);
	background-color: var(--bg-white);
	border-color: transparent;
}

@media (max-width: 1028px) {
	.game-grid-container {
		grid-template-columns: 1fr;
		margin-top: 0px;
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		overflow: auto;
		padding: 10px;
		max-width: 100%;
		/* position: fixed; */
		width: 100%;
		top: unset;
		background-color: #e9ecef;
		/* overflow-x: hidden; */
	}

	.game-left {
		grid-template-columns: 1fr;
		overflow: unset;
		grid-template-rows: unset;
	}

	.cand-dashboard-maincontainer {
		padding: 0px;
		top: 0px;
		height: 100vh;
	}

	.cand-header {
		display: none;
	}

	.game-card {
		height: 200px;
	}

	.game-img-pos {
		width: 40%;
	}

	.game-white-txt-2 {
		margin-top: 20px;
	}

	.game-card .card-body {
		width: 58%;
	}

	.mob-back-header {
		display: flex;
	}
	.game-card .btn-secondary {
		padding: 9px 19px;
	}
}

@media (min-width: 600px) {
	.game-img-pos {
		width: 25%;
	}

	.game-card .card-body {
		width: 68%;
	}

	.game-card {
		height: 230px;
	}
}
</style>
